<template>
    <div class="trade-plateManage-page">
        <p class="hasBottomLine">板块管理后台</p>
        <div class="header-seach-box">
            <!-- <div class="inputWithSelectBox">
              <el-input
                placeholder="输入前，请选择抵押币种或者借贷币种"
                :disabled="serchInfo.selectType == 0 ? true : false"
                v-model="serchInfo.selectCoin"
                class="input-with-select"
              >
                <el-select v-model="serchInfo.selectType" slot="prepend" @change="hanldSelectType()" placeholder="请选择">
                  <el-option label="抵押币种" value="1"></el-option>
                  <el-option label="借贷币种" value="2"></el-option>
                  <el-option label="全部" value="0"></el-option>
                </el-select>
                <el-button slot="append" @click="getPageListInfo()" icon="el-icon-search">搜索</el-button>
              </el-input>
            </div> -->
            <el-button type="success" class="toTransLfet" @click="editBtn({}, 'add')">添加方案</el-button>
        </div>

        <div class="table-box">
            <el-table :data="plateListArr" style="width: 99%">
                <el-table-column property="orderNum" label="序号" width="80"></el-table-column>
                <el-table-column property="id" label="id" width="80"></el-table-column>
                <el-table-column property="name.zh" label="板块名称"></el-table-column>
                <el-table-column property="iconUrl" width="180" label="板块图标">
                    <template slot-scope="scope">
                        <div class="setImgStyle"><img :src="scope.row.iconUrl" alt=""/></div>
                    </template>
                </el-table-column>
                <el-table-column property="createTime" width="180" label="创建时间">
                    <template slot-scope="scope">
                        <span> {{ scope.row.createTime | moment }}</span>
                    </template>
                </el-table-column>
                <el-table-column property="updateTime" width="180" label="更新时间">
                    <template slot-scope="scope">
                        <span> {{ scope.row.updateTime | moment }}</span>
                    </template>
                </el-table-column>
                <el-table-column property="orderNum" label="数量">
                    <template slot-scope="scope">
                        <span> {{ scope.row.pairsJsonArr.length || "--" }}</span>
                    </template>
                </el-table-column>
                <el-table-column property="" label="是否启用">
                    <template slot-scope="scope">
                        <span v-if="scope.row.activated == true">已启用</span>
                        <span v-else style="color:red">停用</span>
                    </template>
                </el-table-column>
                <el-table-column prop="maxDay" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="editBtn(scope.row, 'edit')">修改</el-button>
                        <el-button type="danger" @click="delBtn(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <div class="footer-box">
          <el-pagination
            @size-change="sizeChange"
            @current-change="pageChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="generalListTotal"
          >
          </el-pagination>
        </div> -->

        <!---dialog--->
        <el-dialog title="删除该板块" class="bk-ui5-dialog" :visible.sync="delPlateDialog">
            <p class="descText">
                确认删除该板块：<span style="color:red">{{ editInfo.name }} </span>
            </p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="delPlateDialog = false">取 消</el-button>
                <el-button type="primary" @click="delPlate()">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="dialogTitleText" class="bk-ui5-dialog" :close-on-click-modal="false"
                   :before-close="closeDialog" :visible.sync="editDialog">
            <el-form ref="form" :model="updateInfo" label-width="150px">
                <el-form-item label="板块名称">
                    <el-input v-model="plateNameLang.zh" style="margin-bottom:12px" placeholder="请填写中文名称"></el-input>
                    <el-input v-model="plateNameLang.en" style="margin-bottom:12px" placeholder="请填写英文名称"></el-input>
                    <el-input v-model="plateNameLang.kr" style="margin-bottom:12px" placeholder="请填写韩语名称"></el-input>
                    <el-input v-model="plateNameLang.vi" style="margin-bottom:12px" placeholder="请填写越南名称"></el-input>
                </el-form-item>

                <!-- <el-form-item label="板块简介">
                  <el-input type="textarea" maxlength="100" show-word-limit="true" v-model="updateInfo.description"></el-input>
                </el-form-item> -->

                <el-form-item label="中文简介">
                    <el-input type="textarea" maxlength="2000" show-word-limit="true" v-model="descLang.zh"></el-input>
                </el-form-item>

                <el-form-item label="英文简介">
                    <el-input type="textarea" maxlength="3000" show-word-limit="true" v-model="descLang.en"></el-input>
                </el-form-item>

                <el-form-item label="韩语简介">
                    <el-input type="textarea" maxlength="3000" show-word-limit="true" v-model="descLang.kr"></el-input>
                </el-form-item>
                <el-form-item label="越南简介">
                    <el-input type="textarea" maxlength="3000" show-word-limit="true" v-model="descLang.vi"></el-input>
                </el-form-item>

                <el-form-item label="上传图标">
                    <uploadMoulde :limitNumber="1" v-on:input="getSucessInfo" ref="childUpload"></uploadMoulde>
                </el-form-item>

                <el-form-item label="是否启用">
                    <el-switch v-model="updateInfo.activated"></el-switch>
                </el-form-item>
                <el-form-item label="序号">
                    <el-input-number v-model="updateInfo.orderNum" :min="1" :max="10000000"
                                     label="序号"></el-input-number>
                </el-form-item>
                <el-form-item label="添加币种配置">
                    <div v-for="(item, index) in updateInfo.pairs" style="margin-bottom:12px" :key="'pairs' + index">
                        <el-input v-model="item.pair" placeholder="请添加交易对如： BTC_USDT" style="width: 80%">
                            <template slot="append">
                                <el-button type="primary" round @click="delThisPair(index)">删除
                                    <span>{{ item.pair }}</span></el-button>
                            </template>
                        </el-input>
                        <i class="el-icon-upload2 move-style" @click="movePair(index,'up')"></i>
                        <i class="el-icon-download move-style" @click="movePair(index,'down')"></i>
                    </div>
                </el-form-item>
                <div style="text-align:center">
                    <el-button type="primary" round @click="addPairs()">添加交易对</el-button>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog()">取 消</el-button>
                <el-button type="primary" v-if="diaStatus == 'edit'" @click="commitInfo({}, 'edit')">提 交</el-button>
                <el-button type="primary" v-if="diaStatus == 'add'" @click="createInfo()">新 增</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import "../store";
    import api from "../api";
    import {mapActions, mapGetters, mapState} from "vuex";
    import uploadMoulde from "../../../components/upload/indexLimit.vue";

    export default {
        name: "plateManage",
        data() {
            return {
                editDialog: false,
                dialogTitleText: "板块管理-修改",
                diaStatus: "edit",
                delPlateDialog: false,
                value: "",
                textarea: "",
                editInfo: {},
                selectType: "0",
                serchInfo: {
                    selectType: "1", //0全部  1 抵押币种 2借贷币种
                    selectCoin: "",
                    statusType: "0" //0 全部  1停用 2启用
                },

                currentPage: 1,
                pageSize: 10,

                updateInfo: {
                    activated: false,
                    orderNum: 0,
                    pairs: [""]
                },
                marginFold: [],

                descLang: {
                    zh: "",
                    en: "",
                    kr: "",
                    vi: ""
                },
                plateNameLang: {
                    zh: "",
                    en: "",
                    kr: "",
                    vi: ""
                }
            };
        },
        computed: {
            ...mapState("tradeStatistic", ["plateListArr"])
        },
        methods: {
            ...mapActions("tradeStatistic", ["getPlateList"]),
            movePair(index, type) {
                if (type == 'up') {
                    if (index == 0) {
                        this.$message.info('已经最上面了');
                        return
                    }
                    let temp = this.updateInfo.pairs[index - 1];
                    let curr = this.updateInfo.pairs[index];
                    this.updateInfo.pairs[index - 1] = curr;
                    this.updateInfo.pairs[index] = temp;
                } else {
                    if (index == this.updateInfo.pairs.length - 1) {
                        this.$message.info('已经最下面了');
                        return
                    }
                    let temp = this.updateInfo.pairs[index + 1];
                    let curr = this.updateInfo.pairs[index];
                    this.updateInfo.pairs[index + 1] = curr;
                    this.updateInfo.pairs[index] = temp;
                }
                this.$forceUpdate();
            },
            hanldSelectType() {
                this.serchInfo.selectCoin = "";
            },
            sizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            pageChange(val) {
                console.log(`当前页: ${val}`);
                this.getPageListInfo();
            },

            getPageListInfo() {
                this.getPlateList();
            },

            handleSearch() {
            },
            showDialog(n) {
                this.dialogArr[n] = true;
            },
            handleOpenSwitch(openStatus) {
                this.dialogArr.openSwitchDialog = true;
                return false;
            },
            clearForm() {
                this.editDialog = false;
                this.delPlateDialog = false;
            },

            showDetailBtn() {
            },

            delBtn(row) {
                this.editInfo = JSON.parse(JSON.stringify(row));
                this.delPlateDialog = true;
            },

            closeDialog() {
                this.editDialog = false;
                this.$refs.childUpload.handleRemove();
                this.descLang.zh = "";
                this.descLang.en = "";
                this.descLang.kr = "";
                this.descLang.vi = "";
                this.plateNameLang.zh = "";
                this.plateNameLang.en = "";
                this.plateNameLang.kr = "";
                this.plateNameLang.vi = "";
            },
            //删除该板块
            delPlate() {
                let that = this;
                api.plateDelete({id: that.editInfo.id}).then(res => {
                    if (!res.code) {
                        that.clearForm();
                        that.getPageListInfo();
                        that.$message.success(res.msg);
                    } else {
                        that.$message.error(res.msg);
                    }
                });
            },

            //提交更新信息
            commitInfo() {
                let that = this;
                let resData = {};
                var newMapArr = this.updateInfo.pairs.map(function (item, index, arr) {
                    return item.pair;
                });
                resData = JSON.parse(JSON.stringify(this.updateInfo));
                resData.pairs = newMapArr;

                resData.description = JSON.stringify(this.descLang);
                resData.name = JSON.stringify(this.plateNameLang)
                api.plateUpdate(resData).then(res => {
                    if (!res.code) {
                        that.closeDialog();
                        that.getPageListInfo();
                        that.$message.success(res.msg || "success");
                    } else {
                        that.$message.error(res.msg || "error");
                    }
                });
            },

            createInfo() {
                let that = this;
                let resData = {};
                var newMapArr = this.updateInfo.pairs.map(function (item, index, arr) {
                    return item.pair;
                });
                resData = JSON.parse(JSON.stringify(this.updateInfo));
                resData.pairs = newMapArr;
                resData.description = JSON.stringify(this.descLang);
                resData.name = JSON.stringify(this.plateNameLang)
                api.plateCreate(resData).then(res => {
                    if (!res.code) {
                        that.closeDialog();
                        that.getPageListInfo();
                        that.$message.success(res.msg || "success");
                    } else {
                        that.$message.error(res.msg || "error");
                    }
                });
            },

            getSucessInfo(data) {
                this.updateInfo.iconUrl = data;
                //上传成功
            },

            addPairs() {
                this.updateInfo.pairs.push({id: this.updateInfo.pairs.length + 1, pair: ""});
            },

            delThisPair(index) {
                this.updateInfo.pairs.splice(index, 1);
            },

            editBtn(row, status) {
                if (status == "add") {
                    this.dialogTitleText = "板块管理-新增";
                    this.diaStatus = "add";
                    this.updateInfo = {
                        status: false,
                        orderNum: this.plateListArr.length + 1,
                        pairs: []
                    };
                    this.marginFold = [];
                    this.editDialog = true;
                } else {
                    this.getPleteDetail(row.id); //编辑
                }
            },

            getPleteDetail(id) {
                let that = this;
                api.getPleteDetail({id: id}).then(res => {
                    if (!res.code) {
                        that.updateInfo = JSON.parse(JSON.stringify(res.data));
                        // that.marginFold = JSON.parse(that.updateInfo.leverage);
                        that.dialogTitleText = "板块修改";

                        that.descLang = JSON.parse(res.data.description);
                        that.plateNameLang = JSON.parse(res.data.name);
                        that.diaStatus = "edit";
                        that.editDialog = true;
                    } else {
                        that.$message.error(res.msg);
                    }
                });
            }
        },
        created() {
        },
        mounted() {
            this.getPageListInfo();
        },
        components: {
            uploadMoulde
        }
    };
</script>

<style lang="less">
    .trade-plateManage-page {
        .prosecuteReason {
            width: 452px;
            font-size: 12px;
        }
        .el-textarea__inner {
            height: 100px;
        }
        width: 100%;
        height: 500px;
        .hasBottomLine {
            width: 100%;
            padding-bottom: 18px;
            font-size: 18px;
            margin-bottom: 18px;
            font-weight: bold;
            border-bottom: 1px solid #cccccc;
        }

        .header-seach-box {
            width: 100%;
            margin-bottom: 30px;
            display: flex;
            .inputWithSelectBox {
                width: 500px;
                display: flex;
                .el-input-group__prepend {
                    .el-select {
                        width: 120px;
                    }
                }
                .el-input-group__append {
                    background: #409eff;
                    color: #ffffff;
                }
            }
            .toTransLfet {
                margin-left: 30px;
            }

            .setSelect {
                margin-left: 30px;
                .el-select {
                    margin-left: 12px;
                }
            }
        }

        .table-box {
            width: 100%;
            overflow: hidden;
            .el-table {
                .el-table__header-wrapper {
                    .el-table__header {
                        text-align: center;
                        .cell {
                            text-align: center;
                        }
                    }
                }
                .el-table__body-wrapper {
                    .cell {
                        text-align: center;
                    }
                    .setImgStyle {
                        margin: 0 auto;
                        width: 60px;
                        img {
                            width: 100%;
                        }
                    }
                }
            }
        }

        .footer-box {
            padding: 20px 20px 50px 0px;
        }
        .configItem {
            margin-bottom: 50px;
            padding-bottom: 30px;
            border-bottom: 1px solid #cccccc;
            .item-title {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 18px;
                display: flex;
                align-items: center;
                .el-button {
                    margin-left: 50px;
                }
            }
            .item-action {
                display: flex;
                .desc-box {
                    margin-right: 30px;
                    .imitateInput {
                        min-width: 60px;
                        padding: 12px 20px;
                        display: inline-block;
                        text-align: center;
                        border: 1px solid #cccccc;
                        margin: 0 12px 0;
                    }
                }

                .el-switch.is-disabled {
                    opacity: 1;
                }
                .el-switch .is-disabled .el-switch__core,
                .el-switch.is-disabled .el-switch__label {
                    cursor: pointer;
                }

                .el-switch.is-disabled .el-switch__core,
                .el-switch.is-disabled .el-switch__label {
                    cursor: pointer;
                }
            }
            .item-remark {
                color: #ff8839;
                padding: 1px 0 22px 0;
            }
        }

        .bk-ui5-dialog {
            .move-style {
                padding: 10px;
                cursor: pointer;
                font-size: 18px;
            }
            .move-style:hover {
                color: red;
            }
            .el-dialog {
                width: 40%;
                .el-dialog__header {
                    text-align: center;
                    color: red;
                }
                .el-dialog__body {
                    .titleStrong {
                        font-size: 18px;
                        font-weight: bold;
                    }

                    .el-form {
                        .setSmallInput {
                            .el-form-item__label {
                                width: 170px !important;
                            }
                            .el-form-item__content {
                                margin-left: 170px !important;
                                display: flex;
                                justify-content: space-between;
                                .el-input {
                                    padding-right: 12px;
                                    text-align: center;
                                    .el-input-group__append {
                                        padding: 0 6px;
                                    }
                                }
                                .divText {
                                    width: 200px;
                                    text-align: center;
                                    padding: 0 20px;
                                }
                            }
                        }
                    }

                    .fenFiveInput {
                    }
                }

                .el-dialog__footer {
                    display: flex;
                    justify-content: center;
                }
            }
        }
    }
</style>
